import PropTypes from "prop-types";
import React from "react";
import styles from "./TextArea.module.css";

/*
 * Interactive textarea component with a customizable label and placeholder
 * onChange function is intended to change value for the input box
 */

export function TextArea({
  label,
  value,
  name,
  onChange,
  placeholder,
  onBlur,
  maxLength,
}) {
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (maxLength !== undefined) {
      newValue = newValue.slice(0, maxLength);
    }
    const newEvent = { ...e, target: { ...e.target, value: newValue } };
    onChange && onChange(newEvent);
  };

  return (
    <div className={styles.container}>
      <label htmlFor="textarea" className={styles.label}>
        {label}
      </label>
      <textarea
        type="text"
        id="textarea"
        className={styles.textArea}
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder}
        onBlur={() => onBlur && onBlur(name, value)}
      />
    </div>
  );
}

TextArea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
};
